import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

const MainLayout = ({ children, alert, appStyleLayout }) => {
  const router = useRouter();
  const hasAppParam =
    router.asPath.includes('?app') || router.asPath.includes('&app');
  return (
    <>
      {!hasAppParam && !appStyleLayout && <Header alert={alert} />}
      <main className="main">{children}</main>
      {!hasAppParam && !appStyleLayout && <Footer />}
    </>
  );
};

MainLayout.propTypes = {
  children: PropTypes.any,
  alert: PropTypes.any,
  appStyleLayout: PropTypes.bool,
};

export default MainLayout;
